/**
 * Cart Drawer JS
 * **/

import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const cart = document.querySelector('[data-cart]')
const cartOpen = document.querySelectorAll('[data-cart-open]')
const cartClose = document.querySelectorAll('[data-cart-close]')
const cartOverlay = document.querySelector('[data-cart-overlay]')

// this is required for sprig refreshes
const cartContent = () => document.querySelector('[data-cart-content]')

const lockScroll = () => {
    const el = cartContent()
    if (el) disablePageScroll(el)
}

const unlockScroll = () => {
    const el = cartContent()
    if (el) enablePageScroll(el)
}

const openCart = () => {
    document.body.classList.add('cart--is-open')

    // delay lock + focus for rendering
    setTimeout(() => {
        document.querySelector('.cart__close')?.focus()
        lockScroll()
    }, 250)

    document.addEventListener('keyup', (event) => {
        if(event.key === 'Escape') {
            closeCart()
        }
    })
}

const closeCart = () => {
    document.body.classList.remove('cart--is-open')
    unlockScroll()
}

cartOpen.forEach(el => {
    el.addEventListener('click', (event) => {
        openCart()
    })
})

cartClose.forEach(el => {
    el.addEventListener('click', (event) => {
        closeCart()
    })
})

// Event Delegation for Sprig element replacements
document.addEventListener('click', (event) => {
    if(event.target.closest('.cart__close')) {
        closeCart()
    }
})

if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart)
}

export {openCart, closeCart}
